<template>
  <div class="inventory-holder">
    <div class="flex items-start gap-0">
      <img src="../../assets/warning-danger.svg" alt="" class="w-6" />

      <!-- Inventory text -->
      <div class="disclaimer">
        <p class="text-danger">
          You don't have enough inventory.
        </p>
      </div>
    </div>
    <div class="flex items-start mt-4">
      <img src="../../assets/warning-danger.svg" alt="" class="w-6 opacity-0" />

      <!-- Inventory text -->
      <div class="disclaimer w-full px-2">
        <p class="info">
          Upload an updated Recipient List or select a new list
        </p>
        <!-- Product Display Here -->
        <table>
          <thead>
            <tr>
              <th
                class="product-header"
                v-for="(header, i) in headers"
                :key="i"
              >
                <span>{{ header }}</span>
              </th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="(item, i) in checkInventoryResponse" :key="i">
              <td>{{ item.name }}</td>
              <td>{{ item.option ? item.option : 'N/A' }}</td>
              <td class="product-inventory">{{ item.current_inventory }}</td>
              <td>{{ item.units_required }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InventoryError',
  props: {
    checkInventoryResponse: {
      type: Array,
      default: () => []
    }
  },

  data: () => ({
    headers: ['Items', 'Option', 'Current Inventory', 'Units Required']
  })
}
</script>

<style lang="scss" scoped>
@import '@/global.scss';
.inventory-holder {
  margin-top: 1rem;
  background: #ce3c3c26;
  padding: 2rem;
  width: 97%;
  border-radius: 12px;

  .disclaimer {
    &.px-2 {
      padding: 0px 6px;
    }

    .info {
      font-size: 0.873rem !important;
    }
  }
}

.flex {
  display: flex;
  justify-content: start;
  line-height: 24px;
  gap: 0.5rem;

  &.mt-4 {
    margin-top: 1rem;
  }

  p {
    font-size: 0.913rem;
    text-align: left;
    color: #24292c;

    &.text-danger {
      color: #ce3c3c;
      font-weight: bold;
    }
  }
}

.items {
  width: 100%;
  display: flex;
  padding-top: 2rem;
  margin: 0 2.875rem;

  .header {
    width: 25%;
    text-align: left;
    font-weight: bold;
    color: #24292c;
    font-size: 0.875rem;
    padding-bottom: 2rem;
  }
}

table {
  width: 100%;
  margin-top: 1rem;
  border-spacing: 0px;
  border-collapse: separate;
  // padding: 0 2.75rem;

  & thead > tr > th {
    padding: 1rem 0;
    font-size: 0.813rem;
    text-align: center;
    color: #514d43;
    font-weight: 700;
    width: 30%;

    &:nth-child(1) {
      text-align: left;
    }

    &:nth-child(2) {
      width: 20%;
    }
  }

  & tbody > tr > td {
    padding-bottom: 1rem;
    font-size: 0.813rem;
    text-align: center;

    &:nth-child(1) {
      text-align: left;
    }

    &.product-inventory {
      color: #da5737;
    }
  }
}

@media (max-width: 768px) {
  .inventory-holder {
    padding: 1rem;
  }
}
</style>
